import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const isChunkError =
        this.state.error?.name === 'ChunkLoadError' ||
        this.state.error?.message?.includes('Loading chunk');

      return (
        <div className="flex min-h-screen w-full flex-col items-center justify-center bg-slate-900 px-4 text-white">
          <div className="max-w-md text-center">
            <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-red-500/10 text-red-500">
              <span className="material-icons text-3xl">error_outline</span>
            </div>
            <h2 className="text-xl font-bold">
              {isChunkError ? 'Updated Content Available' : 'Something went wrong'}
            </h2>
            <p className="mt-2 text-sm text-slate-400">
              {isChunkError
                ? 'A new version of this page is available. Click below to refresh.'
                : 'An unexpected error occurred while loading this view.'}
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              className="mt-6 rounded-lg bg-red-600 px-5 py-2.5 text-sm font-semibold text-white shadow-lg transition-colors hover:bg-red-700"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
